import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { BrandLogo } from "@/components/BrandLogo";
import { LiveClock } from "@/components/LiveClock";
import { Button } from "@/components/ui/button";

export function SiteHeader({ isAuthed = false }) {
  const { t } = useLanguage();

  const links = [
    { href: "#services", label: t("nav.services"), index: "01" },
    { href: "#insurance", label: t("nav.insurance"), index: "02" },
    { href: "#process", label: t("nav.process"), index: "03" },
    { href: "#security", label: t("nav.security"), index: "04" },
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4">
        <Link to="/" className="shrink-0">
          <BrandLogo />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Hauptnavigation">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="group flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground">
              <span className="tech-label text-[0.6rem] text-accent-foreground/40 group-hover:text-accent">{l.index}</span>
              <span className="font-medium">{l.label}</span>
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <LiveClock className="hidden text-muted-foreground xl:inline-flex" />
          <div className="hidden h-4 w-px bg-border xl:block" aria-hidden="true" />
          <LanguageSwitcher />
          {isAuthed ? (
            <Button asChild size="sm">
              <Link to="/portal">{t("nav.portal")}</Link>
            </Button>
          ) : (
            <Button asChild size="sm" variant="outline" className="hidden bg-transparent sm:inline-flex">
              <Link to="/sign-in">{t("nav.login")}</Link>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
